var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{staticClass:"success-card"},[_c('Card',[_c('h1',[_vm._v("\n      "+_vm._s(_vm.$t("success"))+"\n    ")]),_c('p',[_vm._v("\n      "+_vm._s(_vm.$t("application_was_sent"))+"\n    ")]),_c('Button',{on:{"click":_vm.goBack}},[_vm._v("Return Home")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }